import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatConfirmDialogComponent } from 'app/mat-confirm-dialog/mat-confirm-dialog.component';



@Injectable({
  providedIn: 'root'
})
export class DialogService {

  constructor(private dialog : MatDialog) { }

  openConfirmDialog(msg){
  return  this.dialog.open(MatConfirmDialogComponent,{
      width:'390px',
      autoFocus :false,
      panelClass: 'confirm-dialog-container',
      disableClose : true,
      position : {top : "120px"},
      data : {
        message : msg
      }
    });
  }


openDialog(component,config){
  return  this.dialog.open(component,config);
  }

}
